package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import migrations.TemplatePageTable

public class TemplatePageTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getTemplatePagesByTemplateId(templateId: String, mapper: (
    id: String,
    templateId: String,
    title: String,
    orderPosition: Long,
  ) -> T): Query<T> = GetTemplatePagesByTemplateIdQuery(templateId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun getTemplatePagesByTemplateId(templateId: String): Query<TemplatePageTable> = getTemplatePagesByTemplateId(templateId, ::TemplatePageTable)

  public fun <T : Any> getTemplatePageById(id: String, mapper: (
    id: String,
    templateId: String,
    title: String,
    orderPosition: Long,
  ) -> T): Query<T> = GetTemplatePageByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun getTemplatePageById(id: String): Query<TemplatePageTable> = getTemplatePageById(id, ::TemplatePageTable)

  /**
   * @return The number of rows updated.
   */
  public fun insertTemplatePage(
    id: String,
    templateId: String,
    title: String,
    orderPosition: Long,
  ): QueryResult<Long> {
    val result = driver.execute(-1_824_005_935, """
        |INSERT INTO TemplatePageTable(id, templateId, title, orderPosition)
        |VALUES (?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   templateId=excluded.templateId,
        |   title=excluded.title,
        |   orderPosition=excluded.orderPosition
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, templateId)
          bindString(parameterIndex++, title)
          bindLong(parameterIndex++, orderPosition)
        }
    notifyQueries(-1_824_005_935) { emit ->
      emit("TemplatePageTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceTemplatePage(
    id: String,
    templateId: String,
    title: String,
    orderPosition: Long,
  ): QueryResult<Long> {
    val result = driver.execute(516_921_173, """
        |INSERT OR REPLACE INTO TemplatePageTable(id, templateId, title, orderPosition)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, templateId)
          bindString(parameterIndex++, title)
          bindLong(parameterIndex++, orderPosition)
        }
    notifyQueries(516_921_173) { emit ->
      emit("TemplatePageTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteTemplatePagesByTemplateId(templateId: String): QueryResult<Long> {
    val result = driver.execute(-1_157_934_308, """DELETE FROM TemplatePageTable WHERE templateId = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, templateId)
        }
    notifyQueries(-1_157_934_308) { emit ->
      emit("TemplatePageTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteTemplatePageById(id: String): QueryResult<Long> {
    val result = driver.execute(1_606_319_925, """DELETE FROM TemplatePageTable WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }
    notifyQueries(1_606_319_925) { emit ->
      emit("TemplatePageTable")
    }
    return result
  }

  private inner class GetTemplatePagesByTemplateIdQuery<out T : Any>(
    public val templateId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("TemplatePageTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("TemplatePageTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-838_565_041, """SELECT TemplatePageTable.id, TemplatePageTable.templateId, TemplatePageTable.title, TemplatePageTable.orderPosition FROM TemplatePageTable WHERE templateId = ? ORDER BY orderPosition ASC""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, templateId)
    }

    override fun toString(): String = "TemplatePageTable.sq:getTemplatePagesByTemplateId"
  }

  private inner class GetTemplatePageByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("TemplatePageTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("TemplatePageTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(809_220_514, """SELECT TemplatePageTable.id, TemplatePageTable.templateId, TemplatePageTable.title, TemplatePageTable.orderPosition FROM TemplatePageTable WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "TemplatePageTable.sq:getTemplatePageById"
  }
}
